import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import VueI18n from 'vue-i18n'
import axios from 'axios'

Vue.config.productionTip = false

Vue.use(VueI18n);

import uz_latin from '../src/components/languages/uz_latin'
import uz_cyril from '../src/components/languages/uz_cyril'
import ru from '../src/components/languages/ru'
import Cookies from "js-cookie"

// Create VueI18n instance with options
let locale = 'uz_latin'
if (store.state.locale != '') {
    locale = store.state.locale
} else {
    store.dispatch('setLocale', locale)
}
const i18n = new VueI18n({
    locale: locale,
    silentTranslationWarn: true,
    messages: {
        'uz_latin': uz_latin,
        'uz_cyril': uz_cyril,
        'ru': ru,
    },
})

Vue.config.productionTip = false
Vue.config.disableNoTranslationWarning = true
Vue.config.silent = false

//-------------------------------------------------------------------------------------
axios.defaults.headers.common = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': Cookies.get('access_token')
    }
    //--------------------------------------------------------------------------------------
if (!!Cookies.get('access_token'))
    axios
    .get(store.state.backend_url + "api/users/show")
    .then(data => {
        let user = data.data;
        let permissions = data.data.roles
            .reduce(
                (accumulator, currentValue) =>
                accumulator.concat(currentValue.permissions), []
            )
            .map(v => v.name);
        let roles = data.data.roles;
        user.roles = null;
        store.dispatch("setUser", data.data);
        store.dispatch("setPermissions", permissions);
        store.dispatch("setRole", roles);
    })
    .catch(e => {
        console.error(e);
    });

axios.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (error.response.status == 401)
        router.push("/login");
    return Promise.reject(error);
});

//-------------------------------------------------------------------------------------------

new Vue({
    i18n,
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')
